import React, { Component } from "react";
const keycode = require("keycode");
const autoBind = require("auto-bind");

export default class Hotkey extends Component {
  _keyPressed = [];
  _modifiers = [];
  _finalShortcut = "";
  constructor(props) {
    super(props);
    //bind this
    autoBind(this);
    this.state = {
      shortcutKey: props.shortcutKey,
      validShortcutKey: props.shortcutKey,
      isValid: true
    };
  }
  componentWillReceiveProps(newProps) {
    if (this.props.shortcutKey !== newProps.shortcutKey) {
      this.setState({
        shortcutKey: newProps.shortcutKey,
        validShortcutKey: newProps.shortcutKey
      });
    }
  }

  handleKeyPress = event => {
    if (event.repeat) {
      return;
    }
    this._keyPressed = [];
    this._modifiers = [];
    this._finalShortcut = "";
    event.stopPropagation();
    event.preventDefault();
    //make default value as valid
    this.setState({
        isValid: true
    });
    console.log("press here! " + event.code);
    this._modifiers.push(event);

    if (!this.isModifier(event.key)) this._keyPressed.push(event);

    var shortcut = this.getShortcutKey();
    this._finalShortcut = this.getFinalShortCut(shortcut);
    this.setState({
      shortcutKey: shortcut
    }); 
  };

  handleKeyUp = event => {
    if (!this.isValidShortcut()) {
      //change color to red
      this.setState({
        isValid: false
      });
    } else {
      this.setState({
        isValid: true
      });
    }
  }
  getFinalShortCut(shortcut) {
    let output = "";
    if (this._modifiers.length <= 0 || this._keyPressed.length <= 0) return;
    let event = this._modifiers[0];
    let modifierDigit = 0;
    if (event.ctrlKey) modifierDigit += 2;
    if (event.shiftKey) modifierDigit += 4;
    if (event.altKey) modifierDigit += 1;
    if (modifierDigit === 0) {
      modifierDigit = 6;
    }
    output = modifierDigit + "|";
    output += this._keyPressed[0].keyCode;

    return output;
  }
  setShortcut(event) {
    if (!this.isValidShortcut()) {
      this.setState({
        shortcutKey: this.state.validShortcutKey,
        isValid: true
      });
      return;
    }
    console.log("setting shortcut to BE " + this._finalShortcut);
    window.SynapseMessenger.setToBE("HotKey", this._finalShortcut);
    this.setState({
      validShortcutKey: this.state.shortcutKey
    });
  }
  getShortcutKey() {
    let shortcutKey = "";
    if (this._modifiers.length > 0) {
      shortcutKey += this.getModifier(this._modifiers[0]) + " + ";
    }
    this._keyPressed.forEach(element => {
      let keyName = keycode(element.keyCode);
      if (typeof keyName !== "undefined") {
        shortcutKey += keyName.toUpperCase() + " + ";
      }
    });
    return (shortcutKey = shortcutKey.substring(0, shortcutKey.length - 3));
  }
  isModifier(key) {
    return key === "Control" || key === "Shift" || key === "Alt";
  }
  getModifier(event) {
    let output = "";
    if (event.ctrlKey) output += "Ctrl" + " + ";
    if (event.shiftKey) output += "Shift" + " + ";
    if (event.altKey) output += "Alt" + " + ";
    if (!output) {
      return "Ctrl" + " + " + "Shift";
    }
    return (output = output.substring(0, output.length - 3));
  }
  isValidShortcut() {
    if (this._modifiers.length === 0) return false;
    if (this._modifiers.length > 0 && this._keyPressed.length === 0)
      return false;
    return true;
  }
  render() {
    let inputStyleObj = this.state.isValid
      ? { width: "216px" }
      : { width: "216px", borderColor: "#c83200" };
    let inputEnableClassName = this.props.isEnabled ? "alexa-not-disabled"
    : "alexa-disabled";
    return (
      <input
        type="text"
        className={`rztextbox ${inputEnableClassName}`}
        spellCheck="false"
        style={inputStyleObj}
        onBlur={this.setShortcut}
        onKeyDown={this.handleKeyPress}
        onKeyUp = {this.handleKeyUp}
        onChange={() => {}}
        value={this.state.shortcutKey}
      />
    );
  }
}
